import { Routes, Route } from 'react-router-dom';
import ProductPage from './pages/ProductPage';
import ProductsListPage from './pages/ProductsListPage';
import AddProductPage from './pages/AddProductPage';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';

function RedirectToSibuzhome() {
  window.location.href = 'https://sibuzhome.com';
  return null;
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Routes>
        {/* Product view */}
        <Route path="/urun/:productId" element={<ProductPage />} />

        {/* Auth */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected admin routes */}
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <ProductsListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-product"
          element={
            <ProtectedRoute>
              <AddProductPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-product/:productId"
          element={
            <ProtectedRoute>
              <AddProductPage editMode />
            </ProtectedRoute>
          }
        />

        {/* Redirect all other routes to sibuzhome.com */}
        <Route path="/" element={<RedirectToSibuzhome />} />
        <Route path="*" element={<RedirectToSibuzhome />} />
        </Routes>
      </AuthProvider>
    </LanguageProvider>
  );
}
